import { SaveAnalyticsAnswerRequest } from '../api';
import { OnboardingResponse, OnboardingResponses } from '../api/responses';
import { getStepsMap } from '../config/steps';
import { Answer, Answers } from './types';

export const mapAnswers = (answers: Answers): OnboardingResponses => {
    const data = Object.keys(answers)
        .filter((questionId: string) => {
            return questionId !== 'phone_number_pp';
        })
        .filter((questionId: string) => {
            return answers[questionId] !== null;
        })
        .map((questionId: string): OnboardingResponse => {
            return {
                question_id: questionId,
                answers: answers[questionId]?.map((answer) => {
                    return {
                        id: answer.value,
                        value: answer.name,
                    };
                }),
            };
        });

    return {
        data,
    };
};

export const mapAnalyticsRequest = (
    answer: Answer,
    userId: string,
    questionId: string,
): SaveAnalyticsAnswerRequest => {
    const STEPS = getStepsMap();

    return {
        userId: userId,
        questionId: STEPS[questionId].id,
        answerId: answer.value,
    };
};
